"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import "./DoctorInfoPanel.css";

import DoctorClinicInfoPanel from "../DoctorClinicInfoPanel/DoctorClinicInfoPanel";
import DoctorPostsPanel from "../DoctorPostsPanel/DoctorPostsPanel";

/**
 * Container uniquement
 * Décide quel panneau afficher selon activeTab
 */
export default function DoctorInfoPanel({ doctor, activeTab }) {
  const { t } = useTranslation();

  if (!doctor) {
    return (
      <div className="doctor-info-panel doctor-info-panel--empty">
        <div className="doctor-info-panel__no-data">
          <p>{t('doctorInfoPanel.noDoctorSelected')}</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="doctor-info-panel"
      role="region"
      aria-label={t('doctorInfoPanel.ariaLabel', { name: doctor.firstName || doctor.name || 'Doctor' })}
    >
      {activeTab === "info" && (
        <DoctorClinicInfoPanel doctor={doctor} />
      )}

      {activeTab === "posts" && (
        <DoctorPostsPanel doctor={doctor} />
      )}

      {/* ✅ Fallback si activeTab invalide */}
      {activeTab !== "info" && activeTab !== "posts" && (
        <div className="doctor-info-panel__invalid-tab">
          <p>{t('doctorInfoPanel.invalidTab')}</p>
        </div>
      )}
    </div>
  );
}